<rask-multi-selector
    class="col-4"
    label="Bärighet"
    [(ngModel)]="searchFilter.barighet"
    bindLabel="text"
    bindValue="value"
    [items]="barighetItems">
</rask-multi-selector>
<rask-multi-selector
    class="col-4"
    label="Ytstruktur"
    [(ngModel)]="searchFilter.ytstruktur"
    bindLabel="text"
    bindValue="value"
    [items]="ytstrukturItems">
</rask-multi-selector>
<rask-multi-selector
    class="col-4"
    label="Lutning"
    [(ngModel)]="searchFilter.lutning"
    bindLabel="text"
    bindValue="value"
    [items]="lutningItems">
</rask-multi-selector>
